module.exports = __webpack_public_path__ + "img/android-prompt.6e9b6606.png";